/// <reference path="../../reference.ts" />

import React from 'react';
import ReactDOM from 'react-dom';
import LoveButton from './loveButton/loveButton.js';
import ImageItem from './imageItem.js';
import VideoItem from './videoItem.js';
import TextItem from './textItem.js';
import VideoItemPlaceholder from './videoItemPlaceholder.js';
import ItemHover from './itemHover.js';
import Texts from './texts/texts.js';
import Social from './social/social.js';
import Share from './share/share.js';
import CustomButton from './buttons/customButton.js';
import ItemTitle from './texts/itemTitle.js';
import consts from '../consts.js';
import cartApi from '../../store/cartApi.js';
import classNames from 'classnames';
import { utils } from '../../utils/index.js';

class ItemView extends React.Component {

  constructor(props) {
    utils.itemLoadStart()
    super(props);

    this.init();

    this.state = {
      failed: false,
      loaded: false,
      retries: 0,
      showShare: false,
      showHover: false,
    }

    this.videoQueue = window.videoQueue;

  }

  //-------------------------------------------| INIT |--------------------------------------------//

  init() {
    this.onItemClick = this.onItemClick.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.toggleFullscreenIfNeeded = this.toggleFullscreenIfNeeded.bind(this);
    this.toggleMultishareSelection = this.toggleMultishareSelection.bind(this);
    this.handleItemMouseDown = this.handleItemMouseDown.bind(this);
    this.handleItemMouseUp = this.handleItemMouseUp.bind(this);
    this.setItemLoaded = this.setItemLoaded.bind(this);
    this.setItemError = this.setItemError.bind(this);
    this.isMultishared = this.isMultishared.bind(this);
    this.isMultisharing = this.isMultisharing.bind(this);
    this.isVerticalContainer = this.isVerticalContainer.bind(this);
    this.toggleShare = this.toggleShare.bind(this);
    this.getShare = this.getShare.bind(this);
    this.getItemHover = this.getItemHover.bind(this);
    this.getImageItem = this.getImageItem.bind(this);
    this.getVideoItem = this.getVideoItem.bind(this);
    this.getTextItem = this.getTextItem.bind(this);
    this.getItemInner = this.getItemInner.bind(this);

    if (utils.isEditor()) {
      Wix.addEventListener(Wix.Events.SETTINGS_UPDATED, (data) => {
        setTimeout(() => {
          this.setState({
            showHover: (data.detail == 2)
          });
        }, 50);
      });
    }

    if (utils.isSemiNative()) {
      this.onMouseOverEvent = new window.CustomEvent('on_mouse_over'); // MUST be 'CustomEvent'
    } else {
      this.onMouseOverEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
      this.onMouseOverEvent.initCustomEvent('on_mouse_over', false, false, null);
    }
  }

  //----------------------------------------| ACTIONS |-------------------------------------------//

  setItemError() {
    this.setState({
      retries: this.state.retries + 1
    });

    if (this.state.retries > 3) {
      console.error('Error (including retries) loading item #' + this.props.idx);
      this.setState({
        failed: true
      });
    }

  }

  setItemLoaded(e) {
    utils.itemLoaded()
    this.setState({
      failed: false,
      loaded: true
    });
  }

  toggleShare(event, forceVal) {
    event.stopPropagation();
    const isIconTag = (tagName) => ['button', 'i', 'a'].indexOf(tagName.toLowerCase()) >= 0;
    if (event.type == "mouseout" && (isIconTag(event.target.tagName) || (event.relatedTarget && isIconTag(event.relatedTarget.tagName)))) {
      //mouseout event should not be fired if hovering over icons (tag name == I)
      return;
    }

    this.setState({
      showShare: (_.isUndefined(forceVal) ? !this.state.showShare : !!forceVal)
    });
  }

  toggleHoverOnMobile() {
    this.setState({
      showHover: !this.state.showHover
    });
  }

  onMouseOver(imageUrl) {
    this.onMouseOverEvent.itemIdx = this.props.idx;
    window.dispatchEvent(this.onMouseOverEvent);
    if (this.props.type == 'video') {
      this.onVideoHover()
    }
  }

  onVideoHover() {
    const {videoPlay, itemClick} = this.props.styleParams
    const canVideoPlayInGallery = utils.isMobile() ? itemClick !== 'expend' : !(itemClick == 'expend' && videoPlay == 'onClick')

    if (this.props.styleParams.videoPlay == 'hover' && !utils.isMobile()) {
      this.props.playVideo(this.props.idx)
    }
  }

  onKeyPress(e) {
    switch (e.keyCode || e.charCode) {
      case 32: //space
      case 13: //enter
        e.preventDefault();
        e.stopPropagation();
        this.onItemClick(e, false); //pressing enter or space always behaves as click on main image, even if the click is on a thumbnail
        return false;
    }
  }

  onItemClick(e, isThumbnail) {
    
    e.preventDefault();
    
    const {itemClick, videoPlay} = this.props.styleParams;

    if (!_.isBoolean(isThumbnail)) isThumbnail = !!this.props.thumbnailHighlightId;

    if (!isThumbnail && _.isFunction(_.get(window, 'galleryWixCodeApi.onItemClicked'))) {
      window.galleryWixCodeApi.onItemClicked(this.props);
    }

    if (isThumbnail === true && _.isFunction(this.props.actions.scrollToItem)) {
      //the click is on a thumbnail
      this.props.actions.scrollToItem(this.props.idx);
    } else {
      if (itemClick == "expand" || itemClick == 'link') {
        // fedopsLogger.interactionStarted('expendModeOpen')
        this.props.actions.toggleFullscreen(this.props.idx);
      }
      else if (itemClick === 'nothing' && utils.isMobile()) {
        this.toggleHoverOnMobile()
      }
      else if (this.props.type == 'video') {
        const shouldTogglePlay = itemClick !== 'expend' && (videoPlay == 'onClick' || utils.isMobile())
        if (shouldTogglePlay) {
          this.props.playing ? this.props.pauseVideo(this.props.idx) : this.props.playVideo(this.props.idx)
        }
      }
    }
  }

  toggleFullscreenIfNeeded(e) {
    var targetClass = _.get(e, 'target.className');
    if (_.isObject(targetClass)) {
      targetClass = _.valuesIn(targetClass);
    }

    if (_.isFunction(targetClass.indexOf) && targetClass.indexOf('block-fullscreen') >= 0) {
      console.warn("Blocked fullscreen!", e);
      return;
    } else if (this.props.styleParams.fullscreen) {
      this.props.actions.toggleFullscreen(this.props.idx);
    }
  };

  toggleMultishareSelection(e) {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    var itemContainer = $(this.itemContainer);
    itemContainer.css({
      transform: 'scale(' + ((this.props.style.width - 8) / this.props.style.width) + ')'
    });
    setTimeout(() => {
      itemContainer.css({
        transform: 'scale(1)'
      });
    }, 80);

    if(this.isMultishared()) {
      this.props.actions.removeItemFromMultishare(this.props)
    } else {
      this.props.actions.addItemToMultishare(this.props)
    }
  }

  handleItemMouseDown(e) {
    if(utils.isMobile() && this.props.styleParams.allowMultishare) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = setTimeout(() => {
        e.preventDefault(); //prevent default only after a long press (so that scroll will not break)
        this.toggleMultishareSelection(e);
      }, 500);
    }
    return true; //make sure the default event behaviour continues
  }

  handleItemMouseUp(e) {
    if(utils.isMobile() && this.longPressTimer) {
      clearTimeout(this.longPressTimer);
    }
    return true; //make sure the default event behaviour continues
  }

  //-----------------------------------------| UTILS |--------------------------------------------//

  isSmallItem() {
    return this.props.isSmallItem && !this.props.styleParams.isSlideshow;
  }

  isVerticalContainer() {
    return this.props.style.width < (this.props.style.height + 1);
  }

  shouldShowHoverOnMobile() {
    return (utils.isMobile() && (this.props.styleParams.itemClick == 'nothing'));
  }

  shouldHover() {
    if (this.isMultisharing()) {
      return true;
    } else if (this.props.styleParams.isSlideshow) {
      return false;
    } else if (utils.isMobile()) {
      return this.shouldShowHoverOnMobile();
    } else if (utils.isEditor()) {
      return this.state.showHover;
    } else {
      return true;
    }
  }

  isMultishared() {
    var items = _.get(this, 'props.multishare.items');
    return items && !!_.find(items, (itemProps) => {
      return (itemProps.id == this.props.id)
    });
  }

  isMultisharing() {
    return _.get(this, 'props.multishare.isMultisharing');
  }

  //---------------------------------------| COMPONENTS |-----------------------------------------//


  getImageDimensions() {
    //image dimensions are for images in grif fit - placing the image with positive margins to show it within the square
    var imageIsWider = this.props.style.ratio >= this.props.cubeRatio;
    var imageMarginLeft = Math.round((this.props.style.height * this.props.style.ratio - this.props.style.width) / -2);
    var imageMarginTop = Math.round((this.props.style.width / this.props.style.ratio - this.props.style.height) / -2);

    return !((this.props.styleParams.cubeImages && this.props.styleParams.cubeType == 'fit')) ? {} : (!imageIsWider ? {
      width: 'calc(100% - 2 * ' + Math.round(imageMarginLeft - this.props.styleParams.imageMargin / 2) + 'px)',
      marginLeft: Math.round(imageMarginLeft - this.props.styleParams.imageMargin / 2)
    } : {
        height: 'calc(100% - 2 * ' + Math.round(imageMarginTop - this.props.styleParams.imageMargin / 2) + 'px)',
        marginTop: Math.round(imageMarginTop - this.props.styleParams.imageMargin / 2)
      });
  }

  isVisible(elment) {
    if (utils.isDev()) {
      console.time('Video isVisible');
      console.count('Video isVisible');
    }
    const domElment = ReactDOM.findDOMNode(elment.video);
    if (!domElment) {
      return false;
    }
    const windowHeight = this.props.documentHeight;
    const scrollPosition = this.props.scroll.top;
    const {top, bottom} = domElment.getBoundingClientRect();
    const videoHeight = bottom - top;
    const tolerance = videoHeight / 2;
    let res = top + tolerance > scrollPosition && bottom - tolerance < scrollPosition + windowHeight;

    if (utils.isDev()) {
      console.timeEnd('Video isVisible');
    }

    return res;
  }

  getButtonPlacement() {
    return utils.isStoreGallery() ? this.props.styleParams.titlePlacement : consts.placements.DONT_SHOW;
  }

  videoOnMount(videoElment) {
    window.videoQueue.addItem({idx: this.props.idx, isVisible: ()=>this.isVisible(videoElment)});
    this.props.videoAdded(window.videoQueue.current());
  }

  videoOnUnmount() {
    window.videoQueue.removeItem(this.props.idx);
  }

  getItemTextsDetails() {
    var props = _.pick(this.props, ['title', 'description', 'fileName', 'id', 'styleParams', 'style', 'isNarrow'])
    let isButtonPlacementOnHover = this.getButtonPlacement() == consts.placements.SHOW_ON_HOVER;
    let isImage = this.props.type == 'image' || this.props.type == 'picture';
    let useCustomButton = this.props.styleParams.useCustomButton == true;
    var shouldShowButton = isButtonPlacementOnHover && isImage && useCustomButton;

    return <Texts {...props}
              key={`item-texts-${props.id}`}
              showShare={this.state.showShare}
              isSmallItem={this.isSmallItem()}
              titlePlacement={this.props.styleParams.titlePlacement}
              shouldShowButton={shouldShowButton} />;
  }

  getSocial() {
    var props = _.pick(this.props, ['id', 'styleParams', 'style', 'love', 'isDemo', 'type', 'download_url', 'originalsUrl', 'isNarrow', 'isShort'])
    return <Social {...props}
              allProps={this.props}
              showShare={this.state.showShare}
              isSmallItem={this.isSmallItem()}
              isVerticalContainer={this.isVerticalContainer()}
              key={`item-social-${props.id}`}
              actions={{
                        openItemShopInFullScreen: this.openItemShopInFullScreen,
                        toggleMultishareSelection: this.toggleMultishareSelection,
                        toggleShare: this.toggleShare,
                        getShare: this.getShare,
                        showTooltip: itemActions.showTooltip,
                        hideTooltip: itemActions.hideTooltip,
                      }}
              />;
  }

  getShare() {
    var props = _.pick(this.props, ['styleParams', 'id', 'type', 'style', 'currentIdx', 'idx'])
    return <Share {...props}
              allProps={this.props}
              key={`item-share-${props.id}`}
              showShare={this.state.showShare}
              isVerticalContainer={this.isVerticalContainer()}
              actions={{
                        toggleShare: this.toggleShare,
                      }}
              />;
  }

  getItemHover(children, imageDimensions) {
    var props = _.pick(this.props, ['styleParams', 'type', 'idx', 'type']);
    return <ItemHover {...props}
            forceShowHover={this.state.showHover}
            isMultisharing={this.isMultisharing()}
            isMultishared={this.isMultishared()}
            shouldHover={this.shouldHover()}
            imageDimensions={imageDimensions}
            key='hover'
            actions={{
                      handleItemMouseDown: this.handleItemMouseDown,
                      handleItemMouseUp: this.handleItemMouseUp,
                      toggleMultishareSelection: this.toggleMultishareSelection,
                    }}
            >
              {children}
            </ItemHover>
  }

  getImageItem(imageDimensions) {
    var props = _.pick(this.props, ['alt', 'title', 'description', 'visible', 'id', 'styleParams', 'resized_url'])
    return <ImageItem {...props}
            key='imageItem'
            loaded={this.state.loaded}
            imageDimensions={imageDimensions}
            isThumbnail={!!this.props.thumbnailHighlightId}
            actions={{
              handleItemMouseDown: this.handleItemMouseDown,
              handleItemMouseUp: this.handleItemMouseUp,
              setItemLoaded: this.setItemLoaded,
              setItemError: this.setItemError,
            }}
           />
  }

  getVideoItem(imageDimensions, itemHover) {
    var props = _.pick(this.props, [])
    return <VideoItem
            {...this.props}
            onMount={this.videoOnMount.bind(this)}
            onUnmount={this.videoOnUnmount.bind(this)}
            onEnd={this.props.videoEnded.bind(this)}
            key={'video' + this.props.idx}
            hover={itemHover}
            imageDimensions={imageDimensions}
            loadingStatus={{
              failed: this.state.failed,
              loaded: this.state.loaded,
            }}
            onClick={this.handleVideoClick}
            actions={_.merge({}, this.props.actions, {
              setItemLoaded: this.setItemLoaded,
              setItemError: this.setItemError,
              handleItemMouseDown: this.handleItemMouseDown,
              handleItemMouseUp: this.handleItemMouseUp,
              toggleMultishareSelection: this.toggleMultishareSelection,
              isMultishared: this.isMultishared,
              isMultisharing: this.isMultisharing,
            })}
            />
  }

  getTextItem() {
    var props = _.pick(this.props, ['visible', 'id', 'styleParams', 'style', 'html', 'cubeRatio'])

    return  <TextItem
              {...props}
              key='textItem'
              actions={{
                handleItemMouseDown: this.handleItemMouseDown,
                handleItemMouseUp: this.handleItemMouseUp,
              }}
              />
  }

  getItemInner() {
    var {styleParams, id, title} = this.props;
    var itemInner;

    var imageDimensions = this.getImageDimensions();
    var itemTexts = this.getItemTextsDetails();
    var social = this.getSocial();
    var share = this.getShare();

    var itemHover = this.getItemHover([itemTexts, social, share], imageDimensions);

    switch (this.props.type) {
      case 'dummy':
        itemInner = <div/>;
        break;
      case 'video':
        if (!this.props.visible) {
          itemInner = <VideoItemPlaceholder id={this.props.idx} resized_url={this.props.resized_url} hover={itemHover} />
        } else {
          itemInner = this.getVideoItem(imageDimensions, itemHover);
        }

        break;
      case 'text':
        itemInner = [this.getTextItem(), itemHover];
        break;
      case 'image':
      case 'picture':
      default:
        itemInner = [this.getImageItem(imageDimensions), itemHover]
    }

    if (styleParams.isSlideshow) {
      itemInner = (<div>
        {itemInner}
        { (this.props.currentIdx === this.props.idx) ?
          <div className="gallery-item-info gallery-item-bottom-info">
            <div>
              {itemTexts}
              {social}
              {share}
            </div>
          </div>
          :
          false
        }
      </div>)
    }

    return itemInner;
  }

  openItemShopInFullScreen(e) {
    e.preventDefault();
    e.stopPropagation();
    this.toggleFullscreenIfNeeded(e, { openShop: true })
  }

  mouseOver(imageUrl) {
    this.onMouseOverEvent.itemIdx = this.props.idx;
    window.dispatchEvent(this.onMouseOverEvent);
  }

  getBottomInfoElement() {
    var {styleParams, style, title, fileName, type, actions} = this.props;
    var displayTitle = (title || fileName)
    var {placements} = consts;
    var buttonPlacement = this.getButtonPlacement();
    var bottomInfo = null;

    if (styleParams.titlePlacement == placements.SHOW_ALWAYS) {
      let buttonElem = null;
      let isImage = type == "image" || type == "picture";
      if (isImage) {
        const shouldShowButton = buttonPlacement == placements.SHOW_ALWAYS && styleParams.useCustomButton === true;
        buttonElem = shouldShowButton ? (<CustomButton styleParams={styleParams} />) : null;
      }
      let isTitleAvailable = styleParams.allowTitle && displayTitle;
      let titleElem = isTitleAvailable ? (<ItemTitle title={displayTitle} />) : null;
      if (titleElem || buttonElem) {
        bottomInfo = (
          <div style={{height: style.bottomInfoHeight, textAlign: styleParams.galleryTextAlign}}
              className="gallery-item-bottom-info"
              onMouseOver={() => {this.setState({showHover: true})}}
              onMouseOut={() => {this.setState({showHover: false})}}>
            {titleElem}
            {buttonElem}
          </div>)
      }
    }
    return bottomInfo;
  }
  //-----------------------------------------| REACT |--------------------------------------------//

  componentDidMount() {
    if (utils.isMobile()) {
      try {
        React.initializeTouchEvents(true);
      } catch (e) {

      }
    }
  }

  componentWillReceiveProps(props) {
    //
  }

  componentDidUpdate(prevProps, prevState) {
    if (utils.isSite() && utils.isAccessibilityEnabled()) {
      //check if thumbnailId has changed to the current item
      const isAnotherItemInFocus = document.activeElement.className.indexOf('gallery-item-container') >= 0;
      const isShowMoreInFocus = document.activeElement.className.indexOf('show-more') >= 0;
      if (isAnotherItemInFocus || isShowMoreInFocus) {
        if ((this.props.thumbnailHighlightId != prevProps.thumbnailHighlightId) && (this.props.thumbnailHighlightId === this.props.id)){
          this.itemContainer.focus();
        }
        //check if currentIdx has changed to the current item
        else if ((this.props.currentIdx != prevProps.currentIdx) && (this.props.currentIdx === this.props.idx)) {
          this.itemContainer.focus();
        }
      }
    }
  }

  //-----------------------------------------| RENDER |--------------------------------------------//

  render() {
    const {styleParams, photoId, id, style, hash, idx, title, type} = this.props;
    const itemInner = this.getItemInner();

    const isHighlight = this.props.thumbnailHighlightId && this.props.thumbnailHighlightId == this.props.id;
    const tabIndex = isHighlight ? utils.getTabIndex('currentThumbnail') : (this.props.currentIdx == this.props.idx ? utils.getTabIndex('currentGalleryItem') : -1);

    var bottomInfo = this.getBottomInfoElement();
    const bottomInfoHeight = this.props.bottomInfoHeight || 0;
    var height = (style.height - styleParams.imageMargin * 2);
    var wrapperWidth = (style.width - styleParams.imageMargin * 2);
    var itemStyle = {};
    itemStyle.backgroundColor = styleParams.cubeType !== 'fit' ? style.bgColor : 'inherit';
    itemStyle.height = height + "px";

    let typeName = 'Graphic';
    switch (type) {
      case 'dummy':
        typeName = '';
        break;
      case 'text':
        typeName = 'Text Box';
        break;
      case 'video':
        typeName = 'Video';
        break;
    }

    const className = classNames('gallery-item-container', 'visible', {
      highlight: isHighlight,
      clickable: styleParams.itemClick !== 'nothing',
    })

    return (
      <div className={className}
           href={itemActions.getShareUrl(this.props)}
           ref={(e) => this.itemContainer = e}
           onMouseOver={() => this.onMouseOver()}
           onClick={this.onItemClick}
           onKeyDown={this.onKeyPress}
           tabIndex={tabIndex}
           data-hash={hash}
           data-id={photoId}
           data-idx={idx}
           aria-label={typeName + ', ' + title + (utils.isStoreGallery() ? ', Buy Now' :'')}
           role="link"
           aria-level="0"
           data-hook="item-container"
           key={'item-container-' + id}
           style={{
             'margin': styleParams.imageMargin + 'px',
             width: wrapperWidth,
             height: height + bottomInfoHeight,
             'position': style.position,
             'top': style.top,
             'left': style.left,
             'right': style.right,
             'bottom': style.bottom,
             'overflowY' : styleParams.isSlideshow ? 'visible' : 'inherit',
           }}>
        <div data-hook="item-wrapper" className={"gallery-item-wrapper visible " + (styleParams.cubeImages ? "cube-type-" + styleParams.cubeType : "")}
          key={'item-wrapper-' + id}
          style={itemStyle}
          >
          {itemInner}
        </div>
        {bottomInfo}
      </div>
    );
  }
}

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

export default ItemView;



// WEBPACK FOOTER //
// ./components/item/itemView.js